import React from 'react';
import styled from 'react-emotion';
import { useApolloClient } from '@apollo/react-hooks';
import { menuItemClassName } from '../components/menu-item';

export default function LogoutButton() {
  const client = useApolloClient();
  return (
    <StyledButton
      data-testid="logout-button"
      onClick={() => {
        client.writeData({ data: { isLoggedIn: false } });
        localStorage.setItem('token', false);
      }}
    >
      Logout
    </StyledButton>
  );
}

/**
 * STYLED COMPONENTS USED IN THIS FILE ARE BELOW HERE
 */

const StyledButton = styled('button')(menuItemClassName, {
  background: 'none',
  border: 'none',
  padding: 0,
});
